import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.div<{ $marketplaceEnabled: boolean }>`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    padding-top: 20px;
    padding-bottom: 40px;

    @media (max-width: 768px) {
        padding-top: 0;
        padding-bottom: 30px;

        flex-direction: column;

        align-items: flex-start;
        justify-content: flex-start;
        gap: 20px;
    }

    ${({ $marketplaceEnabled }) =>
        !$marketplaceEnabled &&
        css`
            padding-bottom: 20px;

            @media (max-width: 768px) {
                padding-bottom: 20px;
            }
        `}
`;

export const LeftSide = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    gap: 10px;
    position: relative;
    z-index: 8;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
        position: unset;
        z-index: unset;
    }
`;

export const RightSide = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 10px;
    position: relative;
    z-index: 8;

    @media (max-width: 768px) {
        flex-direction: row-reverse;
        padding: 0;
        position: unset;
        z-index: unset;
    }
`;

export const ContentHolder = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
`;

export const SecondaryButton = styled(Link)`
    ${styledReset.button}

    display: flex;
    height: 32px;
    padding: 0px 15px;
    justify-content: center;
    align-items: center;

    border-radius: 40px;
    background: rgba(255, 255, 255, 0.1);

    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.24px;
    white-space: nowrap;

    transition: box-shadow 200ms ease;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;

export const ShareButton = styled.button`
    ${styledReset.button}

    display: flex;
    height: 32px;
    padding: 0px 15px 0px 10px;
    justify-content: center;
    align-items: center;
    gap: 5px;

    border-radius: 40px;
    background: linear-gradient(301deg, #523df1 39.32%, #976af6 92.76%);

    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 100%; /* 12px */
    letter-spacing: -0.24px;

    svg {
        width: 18px;
    }

    transition: box-shadow 200ms ease;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;
